import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import * as runtime from '@/api/runtime'
import {
  BatchStatisticsReserveBestSelectItemResult,
  BatchStatisticsReserveBestSelectItemResultFromJSON
} from '@/api/models/batch/BatchStatisticsReserveBestSelectItemResult'
import {
  BatchStatisticsReserveBestRequest,
  BatchStatisticsReserveBestRequestToJSON
} from '@/api/models/batch/BatchStatisticsReserveBestRequest'

/**
 * 帳票作成
 */
export class BatchStatisticsReserveBestApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchStatisticsReserveBestSelectItemResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsReserveBestSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 帳票作成
   * @param request
   */
  async createReserveBest(
    request: BatchStatisticsReserveBestRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/statistics/reserve-best`,
      BatchStatisticsReserveBestRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
